import { Button, strIsNullOrEmpty } from '@fox/atoms';
import { Typography } from '@mui/material';
import MUIAlert from '@mui/material/Alert';
import React from 'react';
import { useTheme } from 'styled-components';
import { useContentContext } from '../../content-context';
import { MemberShipFormTemplate } from '../membership-form-template';
import { MembershipFormFieldTypes } from '../membership-form-template/contracts';
import { redirect } from '../membership-form-template/util';
import { IRegisterMemberFormProps, RegisterMemberFormModel } from './contracts';
import { registerMemberValidationSchema } from './validation-schema';
export const RegisterMemberForm: React.FC<IRegisterMemberFormProps> = ({
	membershipFieldDisplayName,
	redirectUrl,
	termsOfServiceURL,
	loginUrl,
	blockContentAbsoluteUri
}) => {
	const { contentId, requestToken, isLoggedIn } = useContentContext();
	const theme = useTheme();
	if (isLoggedIn) {
		return <MUIAlert severity="info">You are already a member and therefore cannot sign up again.</MUIAlert>;
	}
	return (
		<>
			<MemberShipFormTemplate<RegisterMemberFormModel>
				contentId={contentId}
				recaptcha="memberRegister"
				submitButtonText="Create Account"
				validationSchema={registerMemberValidationSchema}
				initialValues={{
					membershipFieldValue: '',
					accept: false,
					email: '',
					blockContentAbsoluteUri
				}}
				submitFunction={async values => {
					return await fetch('/Umbraco/Api/Membership/SubmitRegisterMember', {
						method: 'POST',
						headers: {
							Accept: 'application/json',
							'Content-Type': 'application/json',
							RequestVerificationToken: requestToken
						},
						body: JSON.stringify({ ...values, contentId })
					});
				}}
				onSuccessFullSubmit={() => {
					if (redirectUrl?.url) {
						redirect(redirectUrl);
					}
				}}
				fields={[
					{
						name: 'email',
						label: 'Email address',
						fieldType: MembershipFormFieldTypes.TextField
					},

					{
						name: 'membershipFieldValue',
						label: membershipFieldDisplayName,
						fieldType: MembershipFormFieldTypes.TextField
					},
					{
						name: 'accept',
						label: (
							<Typography>
								I accept the{' '}
								<span
									style={{
										textDecoration: 'underline',
										color: theme.palette.primary.main,
										cursor: 'pointer'
									}}
									onClick={() => {
										if (termsOfServiceURL?.url) {
											termsOfServiceURL.target = '_blank';
											redirect(termsOfServiceURL);
										}
									}}
								>
									Terms of Service & Privacy Policy
								</span>
							</Typography>
						),
						fieldType: MembershipFormFieldTypes.CheckboxField
					}
				]}
			/>
			{!strIsNullOrEmpty(loginUrl?.url) ? (
				<Button
					sx={{ width: '100%' }}
					variant="secondary"
					onClick={() => {
						redirect(loginUrl);
					}}
				>
					Return to log in
				</Button>
			) : null}
		</>
	);
};
